@if (iframeSrc) {
  <iframe
    class="oboticario-embed"
    [src]="iframeSrc"
    title="Claro + O Boticário"
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
}
